import React from 'react';

function Privacy() {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-900 via-gray-900 to-purple-900">
      <main className="flex-grow py-20 pt-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-4xl font-extrabold text-white sm:text-5xl">
              Privacy Policy
            </h2>
            <p className="mt-4 max-w-2xl text-lg text-gray-300 mx-auto">
              Effective Date: 01/01/2025
            </p>
          </div>
          <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg shadow-lg rounded-lg p-6 sm:p-10 border border-white border-opacity-20">
            <div className="space-y-6 text-white">
              <section>
                <h3 className="text-2xl font-bold">1. Information We Collect</h3>
                <p className="mt-2">
                  WLUMAPS does not collect personal information or location data. We may collect non-identifiable usage data, such as:
                </p>
                <ul className="mt-2 list-disc pl-5">
                  <li>General app usage patterns (e.g., most-viewed classrooms or study spaces).</li>
                </ul>
              </section>
              <section>
                <h3 className="text-2xl font-bold">2. How We Use Your Information</h3>
                <p className="mt-2">
                  We use anonymous usage data solely to:
                </p>
                <ul className="mt-2 list-disc pl-5">
                  <li>Improve and optimize the app’s functionality.</li>
                  <li>Identify trends to enhance the user experience.</li>
                </ul>
              </section>
              <section>
                <h3 className="text-2xl font-bold">3. How We Protect Your Information</h3>
                <p className="mt-2">
                  Since WLUMAPS does not collect personal or location data, there is minimal risk to your privacy. Any anonymous data collected is safeguarded with industry-standard security measures to prevent unauthorized access or misuse.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">4. Sharing Your Information</h3>
                <p className="mt-2">
                  WLUMAPS does not sell, share, or disclose any information to third parties. Anonymous data may be used internally to improve the app and its features.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">5. Third-Party Status</h3>
                <p className="mt-2">
                  WLUMAPS is an independent, third-party service and is not officially affiliated with or endorsed by Wilfrid Laurier University. All images and resources used in WLUMAPS are created, gathered, and owned by WLUMAPS unless otherwise noted.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">6. Cookies and Tracking Technologies</h3>
                <p className="mt-2">
                  WLUMAPS may use cookies or similar technologies to:
                </p>
                <ul className="mt-2 list-disc pl-5">
                  <li>Enhance the app’s functionality and performance.</li>
                  <li>Track non-identifiable app usage data for internal improvements.</li>
                </ul>
                <p className="mt-2">
                  Cookies can be disabled in your browser settings, but certain features of the app may be affected.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">7. Your Rights</h3>
                <p className="mt-2">
                  As WLUMAPS does not collect personal or location information, you retain full anonymity while using the app. There are no additional settings or preferences required to manage your data privacy.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">8. Children’s Privacy</h3>
                <p className="mt-2">
                  WLUMAPS is intended for use by students of Wilfrid Laurier University. The app is not directed toward children under 13, and we do not knowingly collect any information from minors.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">9. Changes to This Privacy Policy</h3>
                <p className="mt-2">
                  We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Updates will be posted on our website. Continued use of WLUMAPS constitutes your acceptance of the updated policy.
                </p>
              </section>
              <section>
                <h3 className="text-2xl font-bold">10. Contact Us</h3>
                <p className="mt-2">
                  If you have questions, concerns, or feedback about this Privacy Policy, please contact us at:
                </p>
                <ul className="mt-2">
                  <li>Email: <a href="mailto:wlumap@gmail.com" className="text-blue-400 underline">wlumap@gmail.com</a></li>
                  <li>Website: <a href="https://wlumap.com" className="text-blue-400 underline">https://wlumap.com</a></li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Privacy;